import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
      },
      infoContainer: {
        marginTop: 24,
        paddingHorizontal: 30,
        marginHorizontal: 30,
        backgroundColor: props.colors.white,
        borderRadius: 20,
        borderWidth: 1,
        borderColor: props.colors.extraLight,
      },
    },
    {
    },
  )();
